"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnterPhoneNumberViewContainer = void 0;
var _EnterPhoneNumberViewContainer = require("./EnterPhoneNumberViewContainer");
var _SourceProvider = require("../SourceProvider");
const EnterPhoneNumberViewContainer = exports.EnterPhoneNumberViewContainer = (0, _SourceProvider.SourceProvider)(_EnterPhoneNumberViewContainer.EnterPhoneNumberViewContainer);